import React from 'react';
import { LuCalendarCheck, LuCalendarClock, LuChevronRight } from 'react-icons/lu';
import CustomShowModal from '../../../components/Common/CustomShowModal';

const options = [
  {
    type: 'current',
    Icon: LuCalendarCheck,
    title: 'Change this date only',
    description: 'Set as actual. Subsequent dates stay as they are.',
  },
  {
    type: 'estimated',
    Icon: LuCalendarClock,
    title: 'Change and adjust subsequent dates',
    description: 'Set as actual. Subsequent dates are recalculated from it.',
  },
];

const DateChangeModal = ({ open, onClose, onConfirm }) => {
  const handleSelect = (type) => {
    onConfirm(type);
    onClose();
  };

  return (
    <CustomShowModal
      open={open}
      handleClose={onClose}
      title="Select Date Change Type"
      contentClassName="!p-3"
    >
      <div className="flex flex-col gap-2">
        {options.map(({ type, Icon, title, description }) => (
          <button
            key={type}
            onClick={() => handleSelect(type)}
            className="group w-full flex items-center gap-3 px-3 py-2 text-left bg-white hover:bg-[#f8fafc] border border-slate-300 hover:border-[#313C4C] focus:border-[#313C4C] rounded-none outline-none transition-colors cursor-pointer"
          >
            <span className="w-7 h-7 flex items-center justify-center bg-slate-100 text-[#313C4C] group-hover:bg-[#313C4C] group-hover:text-white transition-colors">
              <Icon size={14} />
            </span>
            <span className="flex-1 min-w-0 flex flex-col gap-0.5">
              <span className="text-[12px] font-medium text-slate-900 leading-tight">
                {title}
              </span>
              <span className="text-[11px] font-medium text-slate-500 leading-tight">
                {description}
              </span>
            </span>
            <LuChevronRight
              size={14}
              className="text-slate-300 group-hover:text-[#313C4C] group-hover:translate-x-0.5 transition-all"
            />
          </button>
        ))}
      </div>
    </CustomShowModal>
  );
};

export default DateChangeModal;
